import { useEffect, useState } from "react";

type WindowSizesType = {
    width: number,
    height: number
}

const useWindowSizes = (onWindowResize: (sizes: WindowSizesType) => void): WindowSizesType => {
    const [sizes, setSizes] = useState<WindowSizesType>({ width: window.innerWidth, height: window.innerHeight });

    useEffect(() => {
        onWindowResize(sizes)

        const listener = () => {
            setSizes({ width: window.innerWidth, height: window.innerHeight })
            onWindowResize(sizes)
        }

        window.addEventListener('resize', listener)

        return () => window.removeEventListener('resize', listener)
    }, [onWindowResize]);

    return sizes
}

export { useWindowSizes }
